import React, { useEffect, useState } from "react";
import { getDirector } from "../../../Services/APIrequests";
import styles from "../commanstyles.module.css";
import { useParams, useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";

const Directorslist = ({ setCompanyInfo ,refreshLoading}) => {
    const [directorsInfo, setDirectorsInfo] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const { cin } = useParams();
    const navigate = useNavigate();

    // Handle director row click → just navigate

    const handleDirectorClick = (e, director) => {
        e.stopPropagation(); // ✅ prevent parent row click
        if (window.getSelection().toString()) {
            e.stopPropagation();
            return;
        }
        navigate(`/directorviewpage/${cin}/${director.DIN}`);
    };

    // Fetch directors list
    const fetchDirectors = async () => {
        try {
            setLoading(true);
            setError("");
            const response = await getDirector(cin);
            const directors = response?.data?.directors || [];

            setDirectorsInfo(directors);
            setCompanyInfo(directors);
        } catch (err) {
            console.error("Error fetching directors:", err);
            const errorMessage =
                err?.response?.data?.message ||
                err?.message ||
                "Error fetching directors";

            setError(errorMessage);
            setDirectorsInfo([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (cin &&refreshLoading==false) {
            fetchDirectors();
        }
    }, [cin,refreshLoading]);

    if (loading) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}>
                <RotatingLines
                    height="80"
                    width="80"
                    color="#4fa94d"
                    ariaLabel="circles-loading"
                    visible={true}
                />
            </div>
        );
    }

    return (
        <div className={styles["directors_container"]}>
            <h1 id={styles.headertext}>Directors Details</h1>
            <div className={styles.table_subcontainer}>
                <table className={styles.commantable}>
                    <thead className={styles.table_header}>
                        <tr className={styles.tableHeaderRow}>
                            <th className={styles.tableHeader}>Sr. No</th>
                            <th className={styles.tableHeader}>DIN / PAN</th>
                            <th className={styles.tableHeader}>Name</th>
                            <th className={styles.tableHeader}>Designation</th>
                            <th className={styles.tableHeader}>
                                Original Date of Appointment
                            </th>
                            <th className={styles.tableHeader}>
                                Date of Cessation
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {error ? (
                            <tr>
                                <td colSpan="6" className={styles.noDataRow}>
                                    {error}
                                </td>
                            </tr>
                        ) : directorsInfo.length > 0 ? (
                            directorsInfo.map((director, index) => {
                                const isValidDin = /^\d+$/.test(
                                    director.DIN || ""
                                );

                                return (
                                <tr
                                    key={director.DIN || index}
                                    className={styles.tableRow}>
                                    <td className={styles.tableCell}>
                                        {index + 1}
                                    </td>
                                    <td
                                        className={styles.tableCell}
                                        onClick={
                                            isValidDin
                                                ? (e) =>
                                                      handleDirectorClick(
                                                          e,
                                                          director
                                                      )
                                                : undefined
                                        } // ✅ navigate only for valid numeric DINs
                                        style={
                                            isValidDin
                                                ? {
                                                      cursor: "pointer",
                                                      color: "blue",
                                                      textDecoration:
                                                          "underline",
                                                  }
                                                : undefined
                                        }>
                                        {director.DIN || "-"}
                                    </td>
                                    <td className={styles.tableCell}>
                                        {director.Director_Name || "-"}
                                    </td>
                                    <td className={styles.tableCell}>
                                        {director.Designation || "-"}
                                    </td>
                                    <td className={styles.tableCell}>
                                        {director.originalAppointmentDate
                                            ? new Date(
                                                  director.originalAppointmentDate
                                              ).toLocaleDateString("en-GB", {
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                              })
                                            : "-"}
                                    </td>
                                    <td className={styles.tableCell}>
                                        {director.CessationDate
                                            ? new Date(
                                                  director.CessationDate
                                              ).toLocaleDateString("en-GB", {
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                              })
                                            : "-"}
                                    </td>
                                </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="6" className={styles.noDataRow}>
                                    No Director  Details available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Directorslist;
